import CommonPasswordReset from '../../../common/pages/public/PasswordReset'

class PasswordReset extends CommonPasswordReset {
  constructor (props) {
    super(props)
    this.passwordResetFormTitle = '日本型枠工事業協会 [企業管理者]'
    this.userRoleUrl = 'company_admin'
    this.userRole = 'companyAdmin'
  }
}

export default PasswordReset



// WEBPACK FOOTER //
// ./src/company_admin/pages/public/PasswordReset.js